import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
/* Plugins */
import _axios from '@/plugins/axios.ts'
import '@/plugins/roundedDoughnut'
import vuetify from '@/plugins/vuetify'
/* Custom config */
import '@/mixins/globalMixin'
import '@/assets/css/fonts.css'

Vue.config.productionTip = false

// Add global axios instance
Object.defineProperties(Vue.prototype, {
  $axios: {
    get () {
      return _axios
    }
  }
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
